export const PAYMENT_REMOVE_SUCCESS = 'PAYMENT_REMOVE_SUCCESS';
export const PAYMENT_CREATE_SUCCESS = 'PAYMENT_CREATE_SUCCESS';
export const PAYMENT_UPDATE_SUCCESS = 'PAYMENT_UPDATE_SUCCESS';